import { Formik, Field } from "formik";
import React, { useContext } from "react";
import { Button, Form } from "react-bootstrap";
import {
  FieldButtonGroup,
  ManagePlanLayout,
  LoaderWrapper,
  FieldDropSide,
  SearchableList,
  FieldInputNumber,
  WarningModal,
  ApplyToAllStatusToggle,
  HoursComponent,
} from "../../../components";
import {
  yesNoOptions,
  FLOW_TYPES,
  getAdvancedPathWithParam,
  MANAGE_PLAN_ROUTES,
  formFields,
  managePlanFormNames,
  ROUTES,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  getPathWithParam,
} from "../../../utils";
import { useRouterParams, useRequest } from "../../../abstracts";
import { useState } from "react";
import { isEmpty, get } from "lodash";
import {
  GetplanYos,
  listVesting,
  SavePlanYOS,
  getEmploymentStatusList,
} from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import {
  createPlanStore,
  setManageCreateData,
  setManagePlanToastInfo,
} from "../../../contexts";

const YearsOfServiceContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const [showPopUp, setShowPopUp] = useState(false);
  const [isVestingUsed, setIsVestingUsed] = useState(false);
  const [isVesting, setIsVesting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { flow, planId } = useRouterParams();
  const apiData = get(state, "api.data")
    ? get(state, "api.data")
    : get(state, "api.reviewAndPlanDetail");
  const companyId = get(apiData, "companyId");
  const formName = managePlanFormNames.YEARS_OF_SERVICE;

  const fields = formFields[formName];
  const { response: getPlanYosData, loading: yosLoading } = useRequest({
    method: GetplanYos,
    payload: planId,
    defaultResponse: [],
  });
  const { response: getVestingData, loading: vestingLoading } = useRequest({
    method: listVesting,
    payload: planId,
    defaultResponse: [],
  });
  const { response: employmentStatusList } = useRequest({
    method: getEmploymentStatusList,
    payload: companyId,
    defaultResponse: [],
  });

  const usePlanDefaultYOSIndicator = getVestingData?.vestings?.map(
    (_) => _.usePlanDefaultYOSIndicator == true
  );
  const formValues = get(getPlanYosData, "planYOS", {});
  const vestingMethod = get(formValues, "serviceComputation");
  const buttons = [
    {
      link: getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.YEARS_OF_SERVICE,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: ROUTES.PLAN,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => {
        if (getVestingData.isSuccessful) {
          setIsVesting(true);
        }
        if (usePlanDefaultYOSIndicator[0] == true) {
          setIsVestingUsed(true);
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_PLAN_ROUTES.YEARS_OF_SERVICE,
              pathParam: [FLOW_TYPES.SAVE, planId],
            })
          );
        } else {
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_PLAN_ROUTES.YEARS_OF_SERVICE,
              pathParam: [FLOW_TYPES.SAVE, planId],
            })
          );
        }
      },
    },
  ];
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    const updatedValues = {
      ...values,
      computationPeriod: values.computationPeriod ?? 0,
      planId: parseInt(planId),
      equivalencyHoursForEmploymentStatus:
        !values[fields.applyToAllStatuses] &&
        values[fields.serviceComputation] == 3
          ? values.equivalencyHoursForEmploymentStatus
          : formValues !== null &&
            isEmpty(formValues.equivalencyHoursForEmploymentStatus)
          ? formValues.equivalencyHoursForEmploymentStatus?.map((item) => ({
              ...item,
              isDeleted: true,
            }))
          : [],
      hoursOfServiceForEmploymentStatus:
        !values[fields.applyToAllStatuses] &&
        values[fields.serviceComputation] == 1
          ? values.hoursOfServiceForEmploymentStatus
          : formValues !== null &&
            !isEmpty(formValues.hoursOfServiceForEmploymentStatus)
          ? formValues.hoursOfServiceForEmploymentStatus?.map((item) => ({
              ...item,
              isDeleted: true,
            }))
          : [],
    };
    // setIsLoading(true);
    SavePlanYOS(updatedValues).then((response) => {
      if (response.isSuccessful) {
        dispatch(
          setManageCreateData({
            formName: "planYearsOfService",
            fieldData: values,
          })
        );
        setIsLoading(false);
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.YEARS_OF_SERVICE,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      } else {
        setSubmitting(false);
        setIsLoading(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };
  const initialValues = {
    [fields.isPlanYOSApplicable]: false,
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
        [fields.applyToAllStatuses]: get(
          formValues,
          "applyToAllStatuses",
          true
        ),
        hoursOfServiceForEmploymentStatus:
          vestingMethod == 1
            ? get(formValues, "hoursOfServiceForEmploymentStatus", [])
            : [],
        equivalencyHoursForEmploymentStatus:
          vestingMethod == 3
            ? get(formValues, "equivalencyHoursForEmploymentStatus", [])
            : [],

        ...state.planYearsOfService,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        setSubmitting,
        setFieldError,
        setFieldTouched,
        errors,
        setErrors,
        resetForm,
        ...rest
      }) => {
        const clearFields = () => {
          setFieldValue(fields.hoursOfService, null);
          setFieldValue(fields.elapsedTimeInMonths, null);
          setFieldValue(fields.planYOSServiceCreditPeriod, null);
          setFieldValue(fields.computationPeriod, null);
          setFieldValue(fields.activeEmployeesHours, null);
          setFieldValue(fields.dailyHours, null);
          setFieldValue(fields.weeklyHours, null);
          setFieldValue(fields.biWeeklyHours, null);
          setFieldValue(fields.semiMonthlyHours, null);
          setFieldValue(fields.monthlyHours, null);
          setFieldValue(fields.quarterlyHours, null);
          setFieldValue(fields.semiAnnuallyHours, null);
          setFieldValue(fields.annuallyHours, null);
        };

        const handleYOSApplicableChange = (value) => {
          if (value === false) {
            if (usePlanDefaultYOSIndicator[0]) {
              setShowPopUp(true);
            } else {
              setFieldValue(fields.isPlanYOSApplicable, value);
              setFieldValue(fields.serviceComputation, null);
              clearFields();
            }
          } else {
            setFieldValue(fields.isPlanYOSApplicable, value);
            setFieldValue(fields.serviceComputation, null);
            clearFields();
          }
        };
        const handleServiceComputationChange = (value) => {
          setValues({
            ...values,
            [fields.serviceComputation]: value,
            hoursOfServiceForEmploymentStatus:
              value != 1
                ? values.hoursOfServiceForEmploymentStatus?.map((item) => ({
                    ...item,
                    hoursOfService: null,
                  }))
                : values.hoursOfServiceForEmploymentStatus,
            equivalencyHoursForEmploymentStatus:
              value != 3
                ? values.equivalencyHoursForEmploymentStatus?.map((item) => ({
                    ...item,
                    hoursOfService: null,
                  }))
                : values.equivalencyHoursForEmploymentStatus,
          });
          clearFields();
        };

        return (
          <LoaderWrapper isLoading={isLoading || yosLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={flow}
                layoutHeader={"Plan YOS"}
              >
                <p className="plan-sub-heading">Years of Service Details</p>

                <div className="vestingsource-warning">
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className="warning-symbol"
                  />
                  <p className="warning-text">
                    YOS configured here can be referred by Retirement/Vesting
                    computation for YOS credits.
                  </p>
                </div>
                <Field
                  isRequired
                  name={fields.isPlanYOSApplicable}
                  label={"Is Plan level YOS applicable?"}
                  options={yesNoOptions}
                  selectedValue={values[fields.isPlanYOSApplicable]}
                  value={values[fields.isPlanYOSApplicable]}
                  onChange={(value) => {
                    handleYOSApplicableChange(value);
                  }}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                  size="sm"
                />

                {values[fields.isPlanYOSApplicable] == true ? (
                  <>
                    <Field
                      isRequired
                      name={fields.serviceComputation}
                      label={"Service Computation"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.SERVICE_DEFINITIONS
                      )}
                      selectedValue={values[fields.serviceComputation]}
                      value={values[fields.serviceComputation]}
                      onChange={(value) => {
                        handleServiceComputationChange(value);
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                      size="smd"
                    />

                    {values[fields.serviceComputation] === 1 && (
                      <div className="d-flex flex-column">
                        <ApplyToAllStatusToggle
                          title={"Hours of service"}
                          className={"font-hours"}
                          values={values}
                          setValues={setValues}
                          fieldName={fields.applyToAllStatuses}
                          isEdit={isEdit}
                          isSave={isSave}
                          hoursFieldName={fields.hoursOfService}
                          hoursListFieldName={
                            "hoursOfServiceForEmploymentStatus"
                          }
                        />
                        {values[fields.applyToAllStatuses] ? (
                          <Field
                            isRequired
                            name={fields.hoursOfService}
                            selectedValue={values[fields.hoursOfService]}
                            value={values[fields.hoursOfService]}
                            onChange={handleChange}
                            component={FieldInputNumber}
                            min={0}
                            max={9999}
                            disabled={isEdit && !isSave}
                            size="sm"
                          />
                        ) : (
                          <HoursComponent
                            handleChange={handleChange}
                            statusList={employmentStatusList}
                            valueArray={values}
                            isEdit={isEdit}
                            isSave={isSave}
                            name={"hoursOfServiceForEmploymentStatus"}
                          />
                        )}
                      </div>
                    )}

                    {values[fields.serviceComputation] == 2 && (
                      <Field
                        isRequired
                        name={fields.elapsedTimeInMonths}
                        label={"Elapsed Time (months)"}
                        selectedValue={values[fields.elapsedTimeInMonths]}
                        value={values[fields.elapsedTimeInMonths]}
                        onChange={handleChange}
                        component={FieldInputNumber}
                        disabled={isEdit && !isSave}
                        size="smd"
                      />
                    )}

                    {values[fields.serviceComputation] === 3 ? (
                      <div className="d-flex flex-column">
                        <ApplyToAllStatusToggle
                          title={"Hours of service"}
                          className={"font-hours"}
                          values={values}
                          setValues={setValues}
                          fieldName={fields.applyToAllStatuses}
                          isEdit={isEdit}
                          isSave={isSave}
                          hoursFieldName={fields.activeEmployeesHours}
                          hoursListFieldName={
                            "equivalencyHoursForEmploymentStatus"
                          }
                        />
                        {values[fields.applyToAllStatuses] ? (
                          <Field
                            isRequired
                            name={fields.activeEmployeesHours}
                            selectedValue={values[fields.activeEmployeesHours]}
                            value={values[fields.activeEmployeesHours]}
                            onChange={handleChange}
                            component={FieldInputNumber}
                            disabled={isEdit && !isSave}
                            size="sm"
                          />
                        ) : (
                          <HoursComponent
                            handleChange={handleChange}
                            statusList={employmentStatusList}
                            valueArray={values}
                            isEdit={isEdit}
                            isSave={isSave}
                            name={"equivalencyHoursForEmploymentStatus"}
                          />
                        )}
                        <div className="mb-5rm font-hours">
                          {" "}
                          Equivalency hours per frequency{" "}
                        </div>
                        <Field
                          isRequired
                          name={fields.dailyHours}
                          label={"Daily (hours)"}
                          selectedValue={values[fields.dailyHours]}
                          value={values[fields.dailyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={24}
                          size="sm"
                        />

                        <Field
                          isRequired
                          name={fields.weeklyHours}
                          label={"Weekly (hours)"}
                          selectedValue={values[fields.weeklyHours]}
                          value={values[fields.weeklyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={168}
                          size="sm"
                        />

                        <Field
                          isRequired
                          name={fields.biWeeklyHours}
                          label={"BiWeekly (hours)"}
                          selectedValue={values[fields.biWeeklyHours]}
                          value={values[fields.biWeeklyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={336}
                          size="sm"
                        />

                        <Field
                          isRequired
                          name={fields.semiMonthlyHours}
                          label={"SemiMonthly (hours)"}
                          selectedValue={values[fields.semiMonthlyHours]}
                          value={values[fields.semiMonthlyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={384}
                          size="sm"
                        />

                        <Field
                          isRequired
                          name={fields.monthlyHours}
                          label={"Monthly (hours)"}
                          selectedValue={values[fields.monthlyHours]}
                          value={values[fields.monthlyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={744}
                          size="sm"
                        />

                        <Field
                          isRequired
                          name={fields.quarterlyHours}
                          label={"Quarterly (hours)"}
                          selectedValue={values[fields.quarterlyHours]}
                          value={values[fields.quarterlyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={2208}
                          size="sm"
                        />

                        <Field
                          isRequired
                          name={fields.semiAnnuallyHours}
                          label={"SemiAnnually (hours)"}
                          selectedValue={values[fields.semiAnnuallyHours]}
                          value={values[fields.semiAnnuallyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={4392}
                          size="sm"
                        />

                        <Field
                          isRequired
                          name={fields.annuallyHours}
                          label={"Annually (hours)"}
                          selectedValue={values[fields.annuallyHours]}
                          value={values[fields.annuallyHours]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          max={8760}
                          size="sm"
                        />
                      </div>
                    ) : null}

                    {[1, 3].includes(values[fields.serviceComputation]) && (
                      <Field
                        isRequired
                        size="sm"
                        label="Computation Period"
                        name={fields.computationPeriod}
                        value={values[fields.computationPeriod]}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.COMPUTATION_PERIOD
                        )}
                        popupContent={
                          <SearchableList
                            isNotTypeAhead
                            label="Select a Length of service requirement"
                            name={fields.computationPeriod}
                            options={toOptionValuesFromMapper(
                              OPTIONS_DATA_MAPPER.COMPUTATION_PERIOD
                            )}
                            onSelect={(value) =>
                              setFieldValue(fields.computationPeriod, value)
                            }
                            //                            selectedValue={values[fields.computationPeriod]}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                      />
                    )}

                    {values[fields.isPlanYOSApplicable] &&
                      [1, 3].includes(values[fields.serviceComputation]) && (
                        <Field
                          isRequired
                          size="xxl"
                          name={fields.planYOSServiceCreditPeriod}
                          label={"Service Credit period"}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.VESTING_SERVICE_CREDIT_PERIODS
                          )}
                          selectedValue={
                            values[fields.planYOSServiceCreditPeriod]
                          }
                          value={values[fields.planYOSServiceCreditPeriod]}
                          onChange={(value) => {
                            setFieldValue(
                              fields.planYOSServiceCreditPeriod,
                              value
                            );
                          }}
                          component={FieldButtonGroup}
                          disabled={isEdit && !isSave}
                        />
                      )}
                    <WarningModal show={showPopUp}>
                      <div className="remove-text">
                        <p>
                          This YOS is being used downstream in
                          retirement/vesting. Please update the setup in
                          retirement/vesting and then update here.
                        </p>
                        <Button
                          className="cancel-btn"
                          onClick={() => setShowPopUp(false)}
                        >
                          Ok
                        </Button>
                      </div>
                    </WarningModal>
                    <WarningModal show={isVesting}>
                      <div className="remove-text">
                        <p>
                          The changes you made here will be reflected in the
                          vesting plan set up.
                        </p>
                        <Button
                          className="cancel-btn"
                          onClick={() => setIsVesting(false)}
                        >
                          Ok
                        </Button>
                      </div>
                    </WarningModal>
                  </>
                ) : null}
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default YearsOfServiceContainer;
